import packageJson from '../../package.json';
import { VERSION_HEADER_KEY } from '../constants/config';
import { Organisation } from '../enums/common';
import { getOrganisation } from './common';
import { getCookieHelpers } from './cookie';

type Data = Record<string, boolean | number | string | null | Object>;

const logData = (data: Data) => {
    const value = { type: 'error', ...data };
    const LOGS_PATH = import.meta.env.PROD ? 'https://www.ixigo.com/logs/ui' : 'https://build-eks.ixigo.com/logs/ui';

    setTimeout(() => {
        fetch(LOGS_PATH, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/vnd.kafka.json.v2+json',
                [VERSION_HEADER_KEY]: packageJson.version,
                deviceId: data.deviceId as string,
            },
            body: JSON.stringify({
                records: [
                    {
                        value: {
                            appName: 'tara-ui',
                            ...value,
                        },
                    },
                ],
            }),
        }).catch();
    });
};

const logger = (data: Data = {}) => {
    if (getOrganisation() !== Organisation.IXIGO) return;

    const { appVersion, clientId, deviceid: deviceId, uuid } = getCookieHelpers().getAllCookies();

    logData({ ...data, clientId, deviceId, uuid, appVersion });
};

export default logger;
